// extracted by mini-css-extract-plugin
export default {"wrapper":"Faq_wrapper__7nJ-g","title":"Faq_title__YELR3","item":"Faq_item__9eLgO","customControl":"Faq_customControl__qIGcY"};